import { Component, OnInit, ViewChild } from '@angular/core';
import { SeguimientoService } from '../../../services/seguimiento/seguimiento.service';
import { TiendaService } from '../../../services/tienda/tienda.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: false,
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  rangeDates: Date[] = [new Date(), new Date()];
  @ViewChild('calendar') calendar: any;
  token: any = {};
  infoUser: any = {};
  lsTienda: Array<any> = [];
  valorGeneral: number = 0;
  metaGeneral: number = 0;
  greaterQtyProduct: Array<any> = [];
  lessQtyProduct: Array<any> = [];
  lsProduct: Array<any> = [];
  optionsOrder: Array<any> = [{ id: 2, name: 'Ordenar por Venta' }, { id: 1, name: 'Ordenar por Alcance' }];
  optionsProduct: Array<any> = [{ id: 1, name: 'Productos más vendidos (30)' }, { id: 2, name: 'Productos menos vendidos (30)' }];
  selectedOrderBy: any = { id: 1, name: 'Ordenar por Alcance' };
  selectedOptionProduct: any = { id: 1, name: 'Productos más vendidos (30)' };

  //********* */ representación del grafico*********/
  @ViewChild("chart") chart: any;
  public chartOptions: any;
  @ViewChild("chart1") chart1: any;
  public chartOptions1: any;
  @ViewChild("chart2") chart2: any;
  public chartOptions2: any;
  @ViewChild("chart3") chart3: any;
  public chartOptions3: any;
  // Canal de venta
  @ViewChild("chart4") chart4: any;
  public chartOptions4: any;
  //************************************************/



  constructor(private tienda: TiendaService, private seguimiento: SeguimientoService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.lsTienda = JSON.parse(localStorage.getItem('tiendas') ?? "[]");
    this.getInfoVentas(false);

    /******************************Configuration Graphique ************************************************/
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor1 = documentStyle.getPropertyValue('--primary-color');
    const textColor2 = documentStyle.getPropertyValue('--colorSimescco');
    const textColor3 = documentStyle.getPropertyValue('--green-500');

    this.chartOptions = {
      series: [0, 0],
      chart: {
        width: 400,
        type: "pie"
      },
      labels: ["Venta actual", "Faltante a la meta"],
      fill: {
        colors: [textColor3, textColor1]
      },
      yaxis: {
        labels: {
          formatter: function (value: any) {
            return "$ " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");;
          }
        }
      }

    };
    // chart for payments types
    this.chartOptions1 = {
      series: [0, 0],
      chart: {
        width: 400,
        type: "pie"
      },
      labels: ["", ""],
      fill: {
        colors: [textColor3, textColor1]
      },
      yaxis: {
        labels: {
          formatter: function (value: any) {
            return "$ " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");;
          }
        }
      }

    };
    // chart for store
    this.chartOptions2 = {
      series: [{
        name: "Venta",
        data: [0, 0]
      }],
      chart: {
        height: this.lsTienda.length * (this.lsTienda.length > 5 ? 50 : 100),
        type: "bar",
        stacked: false,
        columnWidth: "90%"
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'bottom',
            orientation: 'horizontal'
          }
        }
      },
      colors: [textColor3],
      dataLabels: {
        enable: true,
        textAnchor: "start",
        offsetX: 0,
        style: {
          colors: ["#000"]
        },
        formatter: function (val: any, opt: any) {
          return (opt.dataPointIndex + 1) + '. ' + opt.w.globals.labels[opt.dataPointIndex] + ":  " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        dropShadow: {
          enabled: false
        }
      },
      xaxis: {
        min: 0,
        labels: {
          show: true
        },
        categories: ["", ""]
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      stroke: {
      },
      fill: {
        colors: [textColor2, textColor1]
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        customLegendItems: ["Venta", "Meta"],
        markers: {
          fillColors: [textColor3, textColor2]
        }
      }
    };

    // chart for sales channel
    this.chartOptions4 = {
      series: [0, 0],
      chart: {
        width: 400,
        type: "pie"
      },
      labels: ["", ""],
      fill: {
        colors: [textColor3, textColor1]
      },
      yaxis: {
        labels: {
          formatter: function (value: any) {
            return "$ " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");;
          }
        }
      }

    };


  }

  promiseGetInfoVentas = () => {
    return new Promise((resolve: any) => {
      const dateConvertBegin: string = this.rangeDates[0].getFullYear() + '-' + (this.rangeDates[0].getMonth() + 1) + "-" + this.rangeDates[0].getDate();
      const dateConvertEnd: string = this.rangeDates[1].getFullYear() + '-' + (this.rangeDates[1].getMonth() + 1) + "-" + this.rangeDates[1].getDate();

      Promise.all(this.lsTienda.map((row) => {
        return new Promise((resolve1: any) => {
          //consultar la informaciòn de resumen de pago de cada tienda segun la fecha
          this.tienda.getVentasDiscriminacionPagoTiendaAcumulado(this.token.token, dateConvertBegin, dateConvertEnd, row.idTienda).subscribe((response) => {
            let temp = response as Array<any>;
            let valorVentas: Array<number>;
            let valorTotal: number = 0;
            valorTotal = temp.map(i => {
              // las nota credito no ingresan en el valor total de la venta
              return (i.idVentaMetodoPago != 4) ? i.valor : 0;
            }).reduce((a, b) => { return a + b }, 0);

            row.discriminacionPagos = temp;
            row.valorTotal = valorTotal;


            // obetener los valores de las metas
            this.tienda.getMetasTiendaAcumulado(this.token.token, dateConvertBegin, dateConvertEnd, row.idTienda).subscribe((data: any) => {
              if (data.length > 0)
                row.meta = data.length > 0 ? data[0].valor ?? 0 : 0;
              row.data = [
                ["Venta", row.valorTotal ?? 0],
                ["Meta", row.meta > 0 ? (row.meta - row.valorTotal < 0) ? 0 : row.meta - row.valorTotal : 0]
              ];
              if (row.valorTotal > 0) {
                this.tienda.getVentasDiscriminacionVendedorAcumulado(this.token.token, dateConvertBegin, dateConvertEnd, row.idTienda).subscribe((response1) => {
                  row.infoVentaSales = response1 as Array<any>;

                  /// importar ventas por el canal de ventas
                  this.tienda.getVentasDiscriminacionCanalTiendaAcumulado(this.token.token, dateConvertBegin, dateConvertEnd, row.idTienda).subscribe({
                    next: (responseChannelSales) => {
                      row.channelSales = responseChannelSales as Array<any>;
                      resolve1('OK');
                    },
                    error: (error: HttpErrorResponse) => { console.log(error) }
                  });
                })
              }
              else
                resolve1('OK');
            });
          });
        });

      })
      ).then((values) => {
        resolve('listo');
      })

    });
  }

  getInfoVentas = (isToday: boolean) => {
    this.load = true;
    this.promiseGetInfoVentas().then(() => {
      this.valorGeneral = 0;
      this.metaGeneral = 0;
      // calculo de la venta total y meta
      this.lsTienda.map((row) => {
        this.valorGeneral = this.valorGeneral + row.valorTotal;
        this.metaGeneral = this.metaGeneral + (row.meta ?? 0)
      });

      //******************************************** begin graphique ***********************************************
      this.chartOptions.series = [this.valorGeneral, ((this.metaGeneral - this.valorGeneral) < 0) ? 0 : this.metaGeneral - this.valorGeneral]
      //******************************************** End graphique ************************************************
      // call function order by
      this.setOrderStore();

      let arrayTipoPago: Array<any> = [];
      let arrayVendedor: Array<any> = [];
      let arrayCanalVenta: Array<any> = [];

      // calculo de tipo de pago
      this.lsTienda.map((row) => {

        // Canal de venta
        if (!!row.channelSales)
          row.channelSales.map((item: any) => {
            // filtrando info
            let numItem = arrayCanalVenta.findIndex((data: any) => {
              return data.referencia == item.referencia;
            });
            if (numItem > -1)
              arrayCanalVenta[numItem].valor = arrayCanalVenta[numItem].valor + item.valor;
            else
              arrayCanalVenta.push({ referencia: item.referencia, valor: item.valor })
          });


        // Discriminación de pago
        row.discriminacionPagos.map((item: any) => {
          // filtrando info
          let numItem = arrayTipoPago.findIndex((data: any) => {
            return data.referencia == item.referencia;
          });
          if (numItem > -1)
            arrayTipoPago[numItem].valor = arrayTipoPago[numItem].valor + item.valor;
          else
            arrayTipoPago.push({ referencia: item.referencia, valor: item.valor })
        });

        // discriminación por vendedor
        if (row.valorTotal > 0) {
          row.infoVentaSales.map((data1: any) => {
            let numItem = arrayVendedor.findIndex(row1 => {
              return row1.idEmpleado == data1.empleado.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.idEmpleado
            })
            if (numItem > -1)
              arrayVendedor[numItem].valor = arrayVendedor[numItem].valor + data1.subtotal;
            else
              arrayVendedor.push({
                idEmpleado: data1.empleado.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.idEmpleado,
                nombres: data1.empleado.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.nombres,
                apellidos: data1.empleado.idEmpleadoProveedorVentaNavigation.idEmpleadoNavigation.apellidos,
                valor: data1.subtotal
              });

          })
        }
      });
      // ordenar el array
      arrayTipoPago.sort((a: any, b: any) => {
        return b.valor - a.valor
      });
      arrayVendedor.sort((a: any, b: any) => {
        return b.valor - a.valor
      });
      let index: number = 0;
      //*************************************Begin: Build the information to paint the graphique by vendor */
      let dataSalesGraphique: Array<any> = [];

      const documentStyle = getComputedStyle(document.documentElement);
      const textColor1 = documentStyle.getPropertyValue('--primary-color');
      const textColor2 = documentStyle.getPropertyValue('--colorSimescco');
      const textColor3 = documentStyle.getPropertyValue('--green-500');
      // chart for sales
      this.chartOptions3 = {
        series: [{
          name: "Venta",
          data: [0, 0]
        }],
        chart: {
          height: arrayVendedor.length * (arrayVendedor.length > 5 ? 50 : 100),
          type: "bar",
          stacked: false,
          columnWidth: "90%"
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'bottom',
              orientation: 'horizontal'
            }
          }
        },
        colors: [textColor3],
        dataLabels: {
          enable: true,
          textAnchor: "start",
          offsetX: 0,
          style: {
            colors: ["#000"]
          },
          formatter: function (val: any, opt: any) {
            return (opt.dataPointIndex + 1) + '. ' + opt.w.globals.labels[opt.dataPointIndex] + ":  " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          },
          dropShadow: {
            enabled: false
          }
        },
        xaxis: {
          min: 0,
          labels: {
            show: true
          },
          categories: ["", ""]
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        stroke: {
        },
        fill: {
          colors: [textColor2, textColor1]
        },
        legend: {
          show: true,
          showForSingleSeries: false,
          customLegendItems: ["Venta", "Meta"],
          markers: {
            fillColors: [textColor3, textColor2]
          }
        }
      };

      arrayVendedor.map((row: any) => {
        index++;
        dataSalesGraphique.push({
          x: row.nombres + ' ' + row.apellidos.toUpperCase(),
          y: row.valor,
        })
      });

      this.chartOptions3.series = [{
        type: 'bar',
        label: "Venta por vendedor",
        data: dataSalesGraphique,
      }];



      //*************************************End: Build the information to paint the graphique by vendor */

      // **************************************** Begin build the information to paint the graphique ******************************************
      let referencia: Array<any> = [];
      let valor: Array<any> = [];
      arrayTipoPago.map((row) => {
        referencia.push(row.referencia);
        valor.push(Number(row.valor.toFixed(2)))
      });
      this.chartOptions1.series = valor;
      this.chartOptions1.labels = referencia;
      //******************************************** End graphique ***********************************************
      // **************************************** Begin build the information to paint the graphique ******************************************
      let referencia1: Array<any> = [];
      let valor1: Array<any> = [];
      arrayCanalVenta.map((row) => {
        referencia1.push(row.referencia);
        valor1.push(Number(row.valor.toFixed(2)))
      });
      this.chartOptions4.series = valor1;
      this.chartOptions4.labels = referencia1;
      //******************************************** End graphique *********************************************** 


      // **************************************** End build the information to paint the graphique ******************************************
      this.load = false;

      // información principal de detalle de venta
      const dateConvertBegin: string = this.rangeDates[0].getFullYear() + '-' + (this.rangeDates[0].getMonth() + 1) + "-" + this.rangeDates[0].getDate();
      const dateConvertEnd: string = this.rangeDates[1].getFullYear() + '-' + (this.rangeDates[1].getMonth() + 1) + "-" + this.rangeDates[1].getDate();
      // consulta de los 15 mayores productos vendidos
      this.seguimiento.getDetalleVentasAcumuladoDesc(this.token.token, dateConvertBegin, dateConvertEnd, this.infoUser.empleadoProveedors[0].idProveedor)
        .subscribe((response) => {
          this.greaterQtyProduct = response as Array<any>;
          this.lsProduct = this.greaterQtyProduct;
          // consulta de 15 menores productos vendidos
          this.seguimiento.getDetalleVentasAcumuladoAsc(this.token.token, dateConvertBegin, dateConvertEnd, this.infoUser.empleadoProveedors[0].idProveedor)
            .subscribe((response) => {
              this.lessQtyProduct = response as Array<any>;
            })

        })
    });

  }


  setOrderStore = () => {
    let dataStoreGraphique: Array<any> = [];
    switch (this.selectedOrderBy.id) {
      case 1:
        // sort by goal
        this.lsTienda.sort((a: any, b: any) => {
          return ((a.meta / a.valorTotal) * 100) - ((b.meta / b.valorTotal) * 100)
        })
        break;
      case 2:
        // sort by sales
        this.lsTienda.sort((a: any, b: any) => {
          return b.valorTotal - a.valorTotal
        });
        break;


    }
    //************************************************** Begin Build the information to paint the chart by store ***********************************  */
    this.lsTienda.map((row) => {
      dataStoreGraphique.push({
        x: (row.nombreTienda + ' ' + (row.meta > 0 ? Math.round((row.valorTotal / row.meta) * 100) : 0)) + '%',
        y: row.valorTotal,
        goals: [
          {
            name: "Meta",
            value: row.meta,
            strokeWidth: 5,
            strokeColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-color')
          }
        ]
      })
    });
    this.chartOptions2.series = [{
      type: 'bar',
      label: "Venta realizada",
      data: dataStoreGraphique,
    }];
    //************************************************** End Build the information to paint the chart by store ***********************************  */


  }

  hideDate = () => {
    if ((!this.rangeDates[0]) || (!this.rangeDates[1])) {
      this.calendar.overlayVisible = true;
    }
    else
      this.calendar.overlayVisible = false;
  }

  loadItems = () => {
    if (this.selectedOptionProduct.id == 1)
      this.lsProduct = this.greaterQtyProduct;
    else
      this.lsProduct = this.lessQtyProduct;
  }


}
